import api from "./api";
import endpoints from "./endpoints";

export default {
  getMasterData: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.masterData.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getGlobalAttributes: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.globalAttributeValues.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getVariantAttributes: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.variantAttributeValues.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getInvariantAttributes: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.invariantAttributeValues.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getPriceAttributes: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.priceAttributeValues.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getMediaAssets: async function (variationGroupId, languageCode, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.mediaAssets.get, {
      params: { variationGroupId, languageCode, pagesize, pageOffset }
    });
    return response.data;
  },
  getKeywords: async function (variationGroupId, languageCode, articleId, pagesize, pageOffset) {
    const response = await api.get(endpoints.articleTranslations.keywords.get, {
      params: {
        variationGroupId,
        languageCode,
        articleId,
        pagesize,
        pageOffset
      }
    });
    return response.data;
  },
  getGlobalAttributeSuggestions: async function (sourceLanguage, targetLanguage, value, unit) {
    const response = await api.get(endpoints.articleTranslations.suggestions.globalAttributes.get, { params: { sourceLanguage, targetLanguage, value, unit } });
    return response.data;
  },
  getTextAttributeSuggestions: async function (sourceLanguage, targetLanguage, value, unit) {
    const response = await api.get(endpoints.articleTranslations.suggestions.variantAttributeValues.get, {
      params: { sourceLanguage, targetLanguage, value, unit }
    });
    return response.data;
  },
  getTableAttributeSuggestions: async function (sourceLanguage, targetLanguage, value, unit) {
    const response = await api.get(endpoints.articleTranslations.suggestions.invariantAttributeValues.get, {
      params: { sourceLanguage, targetLanguage, value, unit }
    });
    return response.data;
  },
  getPriceAttributeSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.articleTranslations.suggestions.priceAttributeValues.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  getMediaAssetsSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.articleTranslations.suggestions.mediaAssets.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  getKeywordSuggestions: async function (sourceLanguage, targetLanguage, value) {
    const response = await api.get(endpoints.articleTranslations.suggestions.keywords.get, { params: { sourceLanguage, targetLanguage, value } });
    return response.data;
  },
  translateAllGlobalAttributes: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllGlobalAttributes.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  translateAllVariantAttributes: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllVariantAttributes.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  translateAllInvariantAttributes: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllInvariantAttributes.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  translateAllPriceAttributes: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllPriceAttributes.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  translateAllMediaAssets: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllMediaAssets.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  translateAllKeywords: async function (sourceLanguage, targetLanguage, source, target, onlyEmpty) {
    const response = await api.post(
      endpoints.articleTranslations.translateAllKeywords.get,
      {
        source,
        target,
        sourceLanguage,
        targetLanguage
      },
      { params: { onlyEmptyValues: onlyEmpty } }
    );
    return response.data;
  },
  saveAllTranslationsFromMemory: async function (variationGroupId, sourceLanguage, targetLanguages, onlyEmpty, connectionId) {
    const response = await api.post(endpoints.articleTranslations.saveTranslateAllFromMemory.update, targetLanguages, {
      params: {
        variationGroupId,
        sourceLanguage,
        onlyEmptyValues: onlyEmpty,
        connectionId
      }
    });
    return response.data;
  },
  saveAllTranslationsByDeepL: async function (variationGroupId, sourceLanguage, targetLanguages, onlyEmpty, connectionId) {
    const response = await api.post(endpoints.articleTranslations.saveTranslateAllByDeepL.update, targetLanguages, {
      params: {
        variationGroupId,
        sourceLanguage,
        onlyEmptyValues: onlyEmpty,
        connectionId
      }
    });
    return response.data;
  },
  updateMasterdata: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.masterData.update, model, {
      params: { language, variationGroupId: id }
    });
    return response.data;
  },
  updateGlobalAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.globalAttributeValues.update, model, {
      params: { language, variationGroupId: id }
    });
    return response.data;
  },
  updateVariantAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.variantAttributeValues.update, model, { params: { language, variationGroupId: id } });
    return response.data;
  },
  updateInvariantAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.invariantAttributeValues.update, model, { params: { language, variationGroupId: id } });
    return response.data;
  },
  updateKeywords: async function (languages, keywords, id) {
    const response = await api.post(endpoints.articleTranslations.keywords.update, { languages, keywords }, { params: { variationGroupId: id } });
    return response.data;
  },
  updateMediaAssets: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.mediaAssets.update, model, {
      params: { language, variationGroupId: id }
    });
    return response.data;
  },
  updatePriceAttributes: async function (language, id, model) {
    const response = await api.post(endpoints.articleTranslations.priceAttributeValues.update, model, {
      params: { language, variationGroupId: id }
    });
    return response.data;
  }
};
